let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1aV97")).then(() => parcelRequire('50IoF'));